import * as ko from "knockout";
import {_} from 'lodash';
import {global} from "../../appContext";
import {IRouteDefinitionParams} from "../../index";
import {nsRoute} from "../../util/route";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import httpHtml from './http.html?raw';

export let template = httpHtml;

interface IParams extends IRouteDefinitionParams {
    id: number
}

export class viewModel extends ParsedRouteDataDecorator {

    private id: number;

    constructor(params?: IParams) {
        super(params);
        this.id = params?.id ?? params?.__id ?? 0;
    }

    baseHttp = ko.pureComputed(() => {

        switch (this.id) {
            case 400:
            case 401:
            case 403:
            case 404:
            case 418:
            case 429:
            case 500:
            case 503:
                return {
                    title: `http ${this.id}: title`,
                    body: `http ${this.id}: message`,
                };
            default:
                return {}
        }
    });

    http = ko.pureComputed(() => {
        let ret: any = this.baseHttp();
        ret.code = this.id;
        switch (parseInt(String(this.id).substring(0, 1))) {
            case 2:
                ret = _.extend({
                    title: `http 2xx: title`,
                    body: `http 2xx: message`,
                    alert: `alert alert-success`,
                    icon: `fa fa-check-circle fa-fw`
                }, ret);
                break;
            case 4:
                ret = _.extend({
                    title: `http 4xx: title`,
                    body: `http 4xx: message`,
                    alert: `alert alert-warning`,
                    icon: `fa fa-exclamation-triangle fa-fw`
                }, ret);
                break;
            case 5:
                ret = _.extend({
                    title: `http 5xx: title`,
                    body: `http 5xx: message`,
                    alert: `alert alert-danger`,
                    icon: `fa fa-exclamation-triangle fa-fw`
                }, ret);
                break;
            default:
                ret = _.extend({
                    title: `http: general title`,
                    body: `http: general message`,
                    alert: `alert alert-info`,
                    icon: `fa fa-info-circle fa-fw`
                }, ret);
                break;
        }
        return ret;
    });

    showLink = ko.pureComputed(() => {
        return global.permissionValidator.isMinCompanyAdmin();
    });

}
